<template>
	<div class="empty-container"></div>
</template>

<script>
	export default {}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@include mobile {
		.empty-container {
			min-height: $mobileNavigationHeight;
			min-width: 36px;
		}
	}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItems/EmptyItem.vue